import {
	type QueryClient,
	useQuery,
	useQueryClient
} from '@tanstack/react-query'
import { httpGetCsvUpload } from '@/features/luxe-submissions/http/luxe-submissions.http'
import { CSV_UPLOADS_QUERY_KEY } from '@/features/luxe-submissions/queries/use-get-csv-uploads'
import type {
	CsvUpload,
	CsvUploadsResponse
} from '@/features/luxe-submissions/types'

export const CSV_UPLOAD_QUERY_KEY = 'csv-upload'

const POLL_INTERVAL_MS = 5000

export const csvUploadQueryOptions = (
	id: string,
	queryClient: QueryClient
) => ({
	queryKey: [CSV_UPLOAD_QUERY_KEY, id],
	queryFn: async () => {
		const { upload: fresh } = await httpGetCsvUpload(id)
		queryClient.setQueriesData<CsvUploadsResponse>(
			{ queryKey: [CSV_UPLOADS_QUERY_KEY] },
			(old) => {
				if (!old) {
					return old
				}
				return {
					...old,
					data: old.data.map((upload) =>
						upload.id === fresh.id ? fresh : upload
					)
				}
			}
		)
		return fresh
	},
	refetchInterval: (query: { state: { data?: CsvUpload } }) =>
		query.state.data?.status === 'processing' ? POLL_INTERVAL_MS : false
})

export const useGetCsvUpload = (id: string) => {
	const queryClient = useQueryClient()
	return useQuery(csvUploadQueryOptions(id, queryClient))
}
